import { getNapoleonSiteRootItem } from '@app/mobile/helpers/navigation';
import {
    NavigationDestination,
    NavigationKind,
} from '@app/router/types';
import {
    isBelgium,
    isRomaniaNapoleon,
} from '@modules/layout/utils/isCountry';
import { RouteName } from '@src/app/router/constants/RouteName';
import { NavigationDataStore } from '@store/modules/navigation';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    ComputedRef,
    computed,
} from '@vue/composition-api';

export const useLogoDestination = (): ComputedRef<NavigationDestination | undefined> => {
    const navigationModule = useVuexStore<NavigationDataStore>('navigation');
    const currentTopLevelNavigation = navigationModule.getter('currentTopLevelNavigation');

    return computed(() => {
        if (isBelgium()) {
            return getNapoleonSiteRootItem();
        } else if (isRomaniaNapoleon()) {
            return {
                kind: NavigationKind.SingleDomain,
                location: {
                    name: RouteName.App.Home,
                },
            };
        } else {
            return currentTopLevelNavigation.value?.contextSwitcher.destination;
        }
    });
};
